<script setup lang="ts">
import { useCommonCodeStore } from '~/store/commonCodeStore';
import RoundChart from './round-chart.vue';

const commonCodeStore = useCommonCodeStore();

const props = defineProps<{
  apiData: any,
  property: any,
  style: any,
}>()

const engSource = computed(() => props.property.engSource);

const engData = computed(() => props.apiData ? props.apiData.prodByEngSources.find(v => v.engSource === engSource.value) : '=');

const equipCount = computed(() => props.apiData ? props.apiData.operEquipStatusByRegions.reduce((total, t) => total + t.engSourceInfos.reduce((inTotal, k) => inTotal += (k.engSource === engSource.value ? k.equipCount : 0),0) ,0): '-')

// console.log(engData.value, equipCount.value);

const unitData = computed(() => {
  if(props.property.engSource === '20'){
    return 'm²'
  } else if(props.property.engSource === '10'){
    return 'kWp'
  } else {
    return 'kW'
  }
})

</script>

<template>
  <div class="energy-info-card common-card d-flex">
    <div class="leftArea">
      <div class="header">
        <div class="title">
          <span class="engSource">
            {{ engSource ? commonCodeStore.getMapCode('engSource', engSource)?.codeName : '-' }}
          </span>
          <span class="count">{{ commonUtils.isAllStrDataEmpty(equipCount) }}개</span>
        </div>
      </div>
      <div class="content">
        <div class="content-row">
          <div class="content-key-value">
            <span>설비용량</span>
            <span>{{ commonUtils.isAllStrDataEmpty(commonUtils.unitFormatter(engData.equipCapacity, unitData, 1).value) }}</span>
          </div>
          <span class="content-unit">{{ commonUtils.unitFormatter(engData.equipCapacity, unitData, 1).unit }}</span>
        </div>
        <div class="content-row">
          <div class="content-key-value">
            <span>현재 출력</span>
            <span>{{ typeof engData.currentPower === 'number' ? commonUtils.isAllStrDataEmpty(commonUtils.unitFormatter(engData.currentPower, 'W', 1)).value : '-' }}</span>
          </div>
          <span class="content-unit">{{commonUtils.unitFormatter(engData.currentPower, 'W', 1).unit}}</span>
        </div>
        <div class="content-row" v-if="engSource === '10' || engSource === '40' || engSource === '70' || engSource === '60'">
          <div class="content-key-value">
            <span>금일 발전량</span>
            <span>{{ commonUtils.isAllStrDataEmpty(commonUtils.unitFormatter(engData.todayProdKWH, 'kWh', 1).value) }}</span>
          </div>
        <span class="content-unit">{{ commonUtils.unitFormatter(engData.todayProdKWH, 'kWh', 1).unit }}</span>
        </div>
        <div class="content-row" v-else>
          <div class="content-key-value">
            <span>금일 열사용량</span>
            <span>{{ commonUtils.isAllStrDataEmpty(commonUtils.unitFormatter(engData.todayUsageKWH, 'kWh', 1).value) }}</span>
          </div>
        <span class="content-unit">{{ commonUtils.unitFormatter(engData.todayUsageKWH, 'kWh', 1).unit }}</span>
        </div>
        <div class="content-row">
          <div class="content-key-value">
            <span>금일 CO2 저감량</span>
            <span>{{ commonUtils.isAllStrDataEmpty(commonUtils.unitFormatter(engData.todayCO2Savings, 'kgCO₂eq', 1).value) }}</span>
          </div>
          <span class="content-unit">{{ commonUtils.unitFormatter(engData.todayCO2Savings, 'kgCO₂eq', 1).unit }}</span>
        </div>
      </div>
    </div>
    <div class="rightArea">
      <RoundChart
        :categories="['연동률']"
        :data="[engData.linkageRate ? Number(engData.linkageRate.toFixed(1)) : 0]"
        :color="props.style.chartColor"
      />
    </div>
  

  </div>  
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/energy-card.scss";
@use "@/assets/styles/design-toc/define.scss";
@use "@/assets/styles/design-toc/common-card.scss";
</style>